// Spanish texts of the pages redone in C2 (French is the inline fallback of each t() call)
const es = {
    navigation: {
        merge: "Fusión",
        zones: "Config. de zonas",
        auctions: "Subastas",
        recovery: "Recuperación",
        pl: "Servicio PL",
        personnages: "Personajes"
    },
    dashboard: {
        mergeManagement: "Fusión de clasificaciones entre servidores",
        zonesManagement: "Zonas propuestas para las reservas",
        auctionsManagement: "Zonas libres en subasta",
        recoveryManagement: "Mensajes que el bot no vio, por validar",
        plManagement: "Beneficiarios y préstamos de panoplias de sabiduría",
        personnagesManagement: "Personajes de los miembros y solicitudes por validar"
    },
    channelConfig: {
        title: "Configuraciones de canales",
        subtitle: "Gestiona varias configuraciones de canales para distintas secciones del servidor"
    },
    bareme: {
        baremesPlural: "baremos",
        baremeSingular: "baremo"
    },
    events: {
        unknownType: "Tipo desconocido",
        multipliers: {
            double: "Doble",
            triple: "Triple"
        }
    },
    server: {
        loadError: "❌ Error al cargar los datos",
        channelsPlural: "canales",
        channelSingular: "canal",
        rolesPlural: "roles",
        roleSingular: "rol",
        hideHelp: "Ocultar la ayuda",
        showHelp: "Ayuda",
        siteAdminRole: "Rol de Administrador de Discord (solo indicativo)",
        botMonitoring: "Vigilancia automática del bot",
        botMonitoringTitle: "Vigilancia automática",
        botMonitoringDesc: "El bot de Discord vigila automáticamente los canales configurados abajo para detectar las capturas de combate (ataques y defensas) y registrarlas en el sistema.",
        monitoredChannels: "Canales vigilados",
        noMonitoring: "Ningún canal configurado - el bot no vigila ningún canal",
        types: "tipos"
    },
    seasons: {
        loadingError: "Error al cargar la temporada",
        autoPublishEnabled: "Publicación automática activada",
        loading: "Cargando temporadas",
        noSeasonsMessage: "Empieza creando tu primera temporada para organizar tus competiciones.",
        createFirstSeason: "Crear la primera temporada",
        noResultsMessage: "Ninguna temporada coincide con tus criterios de búsqueda."
    },
    alliance: {
        season: "Temporada",
        noSeason: "Ninguna temporada en curso",
        noSeasonHint: "Los administradores anunciarán la próxima temporada.",
        currentSeason: "Temporada en curso",
        seasonProgress: "Avance de la temporada",
        lastDay: "Último día",
        daysLeft: "Quedan {n} días",
        reservationSheet: "Ficha de reserva",
        swapPhase: "Fase de intercambio",
        inProgress: "En curso",
        finished: "Terminada",
        viewSheet: "Ver la ficha",
        noSheet: "Ninguna ficha en curso",
        noSheetHint: "La ficha aún no se ha publicado.",
        auctions: "Subastas",
        auctionsOpen: "Subastas abiertas",
        auctionsClosed: "Subastas cerradas",
        until: "Hasta el {date}",
        opensAtEndOf: "Apertura al final de la temporada",
        opensAtEndOfCurrent: "Apertura al final de la temporada en curso.",
        topBid: "Puja más alta",
        topZonePrev: "Zona top (temp. anterior)",
        joinAuctions: "Participar en las subastas",
        myPepites: "Mis pepitas",
        owedToYou: "Se te debe",
        lastDistribution: "Última distribución el {date}",
        received: "{n} recibidas",
        paidNextDistribution: "Se pagan en la próxima distribución",
        myZones: "Mis zonas esta temporada",
        noZoneOnSheet: "No tienes ninguna zona asignada en la ficha actual.",
        noZoneYet: "Ninguna zona reservada por ahora.",
        checkPreferences: "Revisar mis preferencias",
        sourceAuction: "Subasta",
        sheetFrozen: "Ficha congelada",
        provisional: "Provisional",
        myAuctions: "Mis subastas",
        noBidYet: "Todavía no has pujado por ninguna zona.",
        noLastAuction: "No participaste en la última subasta.",
        leading: "En cabeza",
        outbid: "Superado",
        zonesWon: "{n} zonas ganadas",
        zoneWon: "{n} zona ganada",
        yourBid: "Tu puja: {n}",
        bestBidVsYours: "Mejor puja: {n} · la tuya: {mine}",
        won: "Ganada",
        topBidChip: "Puja más alta",
        lost: "Perdida",
        noZoneWon: "Ninguna zona ganada.",
        rebid: "Volver a pujar",
        viewAuctions: "Ver las subastas",
        loadError: "No se pudo cargar la información.",
        theAlliance: "La alianza",
        me: "Yo"
    },
    member: {
        nav: {
            general: "Información general",
            stats: "Mis estadísticas",
            preferences: "Mis preferencias",
            sheet: "Ficha de reserva",
            auctions: "Subastas",
            personnages: "Mis personajes"
        }
    },
    adminHome: {
        memberArea: "Espacio de miembro",
        resaCard: "Ficha de reserva",
        openSheet: "Abrir la ficha",
        reservations: "Reservas",
        disabled: "Desactivadas",
        noActiveSheet: "Ninguna ficha activa.",
        activeSheet: "Ficha activa",
        memberSwaps: "Intercambios entre miembros",
        open: "Abiertos",
        closed: "Cerrados",
        assignments: "Asignaciones",
        automatic: "Automáticas",
        frozen: "Congeladas",
        openAuctions: "Abrir las subastas",
        status: "Estado",
        noAuction: "Ninguna subasta abierta",
        auctionOpen: "Abiertas",
        auctionToClose: "Terminadas, por cerrar",
        end: "Fin",
        endedOn: "Terminada el",
        bidsTotal: "Total de pujas",
        zonesWithBid: "Zonas con una puja",
        bidsN: "{n} pujas",
        bidN: "{n} puja",
        rightNow: "Ahora mismo"
    },
    memberStats: {
        attacks: "Ataques",
        defenses: "Defensas",
        atkDefTitle: "Ataques / defensas",
        fightsAllSeasons: "{n} combates en todas las temporadas",
        fightAllSeasons: "{n} combate en todas las temporadas",
        range24h: "24 h",
        range7d: "7 días",
        range30d: "30 días",
        activityTitle: "Horarios de actividad",
        activitySubtitle: "Combates por hora · hora de París",
        period: "Periodo",
        noActivity: "Ninguna actividad en este periodo",
        fightType: "Tipo de combate",
        season: "Temporada",
        atkPts: "Pts ataque",
        defPts: "Pts defensa",
        rank: "Puesto",
        total: "Total",
        attacks5v5: "Ataques 5v5",
        defenses5v5: "Defensas 5v5",
        in4v5: "{n} en 4v5",
        totalPoints: "Puntos totales",
        allSeasons: "todas las temporadas",
        bestRank: "Mejor puesto",
        avgPerSeason: "Media / temporada",
        seasonsPlayed: "{n} temporadas jugadas",
        seasonPlayed: "{n} temporada jugada",
        bestScore: "Mejor puntuación",
        inOneSeason: "en una temporada",
        loading: "Cargando estadísticas...",
        loadError: "No se pudieron cargar tus estadísticas.",
        emptyHint: "Tus estadísticas aparecerán al final de tu primera temporada.",
        splitActivity: "Reparto y actividad",
        perSeason: "Detalle por temporada"
    },
    prefs: {
        saved: "Preferencias guardadas",
        saveError: "Error al guardar las preferencias",
        loading: "Cargando tus preferencias...",
        title: "Mis preferencias de zonas",
        zonesToRank: "{n} zonas por clasificar",
        saving: "Guardando...",
        save: "Guardar",
        unsaved: "Cambios sin guardar",
        savedOn: "Preferencias guardadas el {date} a las {time}",
        notSavedYet: "Todavía no has guardado preferencias: se usa el orden por defecto del servidor.",
        ranking: "Clasificación",
        searchPlaceholder: "Buscar una zona o una mazmorra...",
        searchLabel: "Buscar una zona",
        resultsHint: "{n} resultados · borra la búsqueda para poder arrastrar las filas",
        resultHint: "{n} resultado · borra la búsqueda para poder arrastrar las filas",
        dragHint: "Arrastra las filas, usa las flechas o haz clic en un puesto para escribirlo. #1 = tu zona favorita.",
        noMatch: "Ninguna zona coincide con «{q}»",
        rank: "Puesto",
        move: "Mover",
        zone: "Zona",
        dungeon: "Mazmorra",
        newRankFor: "Nuevo puesto para {zone}",
        clickToEditRank: "Haz clic para escribir un puesto",
        dragToMove: "Arrastra para mover",
        moveUp: "Subir {zone}",
        moveDown: "Bajar {zone}"
    },
    sheet: {
        confirmSwap: "¿Cambiar «{from}» por «{to}»?",
        noZone: "ninguna zona",
        swapDone: "Tu zona ahora es «{zone}»",
        swapError: "No se pudo hacer el intercambio",
        loading: "Cargando la ficha...",
        loadError: "No se pudo cargar la ficha actual.",
        noSheet: "Ninguna ficha de reserva en curso por ahora.",
        myZones: "Mis zonas",
        swapOpen: "Fase de intercambio en curso",
        swapClosed: "Fase de intercambio terminada",
        frozen: "Ficha congelada",
        notRegistered: "No estás inscrito en esta ficha.",
        noZoneYet: "Aún sin zona",
        cancel: "Cancelar",
        changeZone: "Cambiar de zona",
        auction: "Subasta",
        pickFreeZone: "Elige una zona libre para reemplazar",
        yourSpot: "tu plaza",
        freeCountPlural: "{n} libres",
        freeCount: "{n} libre",
        searchZone: "Buscar una zona...",
        searchFreeZone: "Buscar una zona libre",
        allTaken: "Todas las zonas están ocupadas.",
        freeZones: "Zonas libres",
        freeAfterAuction: "Hay una subasta en curso en esta ficha: las zonas libres se mostrarán cuando se cierre la subasta.",
        freeMayChange: "Los intercambios están abiertos: esta lista aún puede cambiar.",
        noFreeMatch: "Ninguna zona libre coincide.",
        allReservations: "Todas las reservas",
        reservationsCount: "{n} reservas",
        reservationCount: "{n} reserva",
        searchTablePlaceholder: "Jugador o zona...",
        searchTable: "Buscar en la ficha",
        player: "Jugador",
        zone: "Zona",
        dungeon: "Mazmorra",
        me: "yo",
        auctionChip: "subasta"
    },
    auctionMember: {
        filterAll: "Todas",
        filterMine: "Mis pujas",
        filterFree: "Sin puja",
        favorite: "Añadir a favoritos",
        unfavorite: "Quitar de favoritos",
        favoriteError: "No se pudo guardar el favorito",
        confirmBid: "¿Pujar {amount} por «{zone}»?\n\nUna puja no se puede retirar.",
        won: "Ganada",
        leading: "En cabeza",
        outbid: "Superado",
        bids: "{n} pujas",
        bid: "{n} puja",
        startsAt: "Salida en {amount}",
        wonBy: "Ganada por {name}",
        endedNoBid: "Terminada sin pujas",
        bidAmount: "Pujar {amount}",
        otherAmount: "Otra cantidad (mín. {min})",
        otherAmountOn: "Otra cantidad por {zone}",
        placeBid: "Pujar",
        bidExtended: "Puja registrada por «{zone}» · anti-snipe: la zona se prolonga",
        nowLeading: "Vas en cabeza en «{zone}»",
        bidError: "No se pudo registrar la puja",
        loadError: "No se pudieron cargar las subastas.",
        subtitle: "Las zonas que quedaron libres tras la fase de intercambio",
        noneRunning: "Ninguna subasta en curso",
        noneRunningHint: "Las subastas abren al final de la temporada, tras la fase de intercambio de la ficha de reserva.",
        lastAuction: "Última subasta",
        youWon: "Has ganado:",
        noneSold: "Ninguna zona vendida.",
        endsIn: "termina en {time}",
        ruleStart: "Salida {amount}",
        ruleIncrement: "Puja mínima de {amount} más",
        ruleSnipe: "Anti-snipe: una puja en los últimos {n} minutos añade {n} min",
        ruleNoWithdraw: "No se puede retirar una puja",
        leadingOnZones: "En cabeza en {n} zonas",
        leadingOnZone: "En cabeza en {n} zona",
        outbidOnZones: "Superado en {n} zonas",
        outbidOnZone: "Superado en {n} zona",
        zonesUp: "{n} zonas en subasta",
        filterZones: "Filtrar las zonas",
        searchZone: "Buscar una zona...",
        searchZoneLabel: "Buscar una zona",
        noMatch: "Ninguna zona coincide."
    },
    pepitesAdmin: {
        loadError: "Error al cargar las pepitas",
        channelSaved: "¡Canal de pepitas configurado!",
        saveError: "Error al guardar",
        confirmDelete: "¿Eliminar esta entrada? Esta acción es irreversible.",
        entryDeleted: "Entrada eliminada",
        deleteError: "Error al eliminar",
        invalidAmount: "Cantidad no válida",
        entryUpdated: "Entrada modificada",
        updateError: "Error al modificar",
        nothingToDistribute: "No hay pepitas que distribuir por ahora",
        copied: "{n} copiado",
        unpaidWarning: "{n} jugador(es) no están marcados como pagados.",
        confirmFinish: "¿Terminar la distribución? Los contadores se pondrán a cero y se guardará un archivo.",
        finished: "Distribución terminada, contadores a cero",
        archiveError: "Error al archivar las pepitas",
        subtitle: "Gestión de las pepitas de la alianza",
        payTitle: "Muestra las cantidades que dar en el juego, luego archiva y pone los contadores a cero",
        pay: "Pagar y redistribuir",
        recycled: "Pepitas recicladas",
        toRedistribute: "Por redistribuir ({rate})",
        players: "Jugadores",
        entries: "Entradas",
        channelTitle: "Canal de pepitas",
        currentChannel: "Canal actual:",
        channelDesc: "Cuando un jugador publica en este canal un mensaje con un número y una captura, el bot registra automáticamente sus pepitas.",
        discordChannel: "Canal de Discord",
        selectChannel: "-- Seleccionar un canal --",
        saving: "Guardando...",
        perPlayer: "Resumen por jugador",
        searchPlayer: "Buscar un jugador...",
        searchPlayerLabel: "Buscar un jugador",
        noPlayerMatch: "Ningún jugador coincide con la búsqueda",
        noneYet: "Todavía no hay pepitas registradas",
        configureFirst: "Configura primero un canal de Discord arriba.",
        player: "Jugador",
        totalPepites: "Total de pepitas",
        toGive: "Por dar ({rate})",
        lastEntry: "Última entrada",
        hide: "Ocultar",
        details: "Detalles",
        date: "Fecha",
        amount: "Cantidad",
        note: "Nota",
        noEntry: "Ninguna entrada",
        newAmount: "Nueva cantidad",
        validate: "Validar",
        editAmount: "Modificar la cantidad",
        deleteEntry: "Eliminar la entrada",
        history: "Historial de distribuciones",
        noHistory: "Todavía no hay distribuciones archivadas.",
        distributionOf: "Distribución del {date}",
        by: "Por {name}",
        recycledLower: "pepitas recicladas",
        paidOut: "pagadas ({rate} %)",
        playersRewarded: "jugadores recompensados",
        entriesCounted: "entradas contabilizadas",
        topPlayers: "Mejores jugadores:",
        payMode: "Modo de pago",
        payIntro: "Da en el juego la cantidad indicada a cada jugador ({rate} de sus pepitas recicladas) y márcalo. Las marcas solo sirven para seguir el pago.",
        toGiveInGame: "Por dar en el juego ({rate})",
        paid: "Pagados",
        recycledCount: "{n} recicladas",
        copyAmount: "Copiar la cantidad",
        later: "Más tarde",
        archiving: "Archivando...",
        finishReset: "Terminar y poner a cero"
    },
    zonesAdmin: {
        copyDiscard: "Tus cambios sin guardar serán reemplazados. ¿Continuar?",
        copyEmpty: "Este servidor no tiene zonas",
        copyDone: "Lista copiada desde {server}: revísala y luego guarda",
        copyError: "No se pueden cargar las zonas de este servidor",
        copyTitle: "Copiar desde otro servidor",
        copyDesc: "Toma la lista y el orden de las zonas de otro servidor. Las zonas BDA de este servidor siguen siendo BDA (y se conservan aunque el otro servidor no las tenga). No se guarda nada hasta hacer clic en «Guardar».",
        copySource: "Servidor de origen",
        copyPick: "— Elegir un servidor —",
        copyBtn: "Copiar la lista",
        loadError: "Error al cargar las zonas",
        alreadyExists: "La zona «{zone}» ya existe",
        confirmRemoved: "{n} zona(s) eliminada(s) también se quitarán de las preferencias de los miembros.\n\n¿Guardar la lista?",
        prefsUpdated: "{n} lista(s) de preferencias actualizada(s)",
        saved: "Zonas guardadas",
        saveError: "Error al guardar",
        confirmReset: "¿Volver a la lista de zonas por defecto?\n\nSe borrará la lista personalizada de este servidor.",
        resetDone: "Lista por defecto restablecida",
        resetError: "Error al restablecer",
        subtitle: "Zonas propuestas a los miembros para las reservas",
        saving: "Guardando...",
        save: "Guardar",
        zones: "Zonas",
        bdaZones: "Zonas BDA (privatizadas)",
        custom: "Personalizada",
        default: "Por defecto",
        modifiedOn: "Lista modificada el {date}",
        serverList: "Lista del servidor",
        addTitle: "Añadir una zona",
        addDesc: "Las nuevas zonas se añaden al final de la lista y al final de la clasificación de los miembros que ya rellenaron sus preferencias.",
        zone: "Zona",
        zonePlaceholder: "Ej.: NILEZA",
        dungeonOptional: "Mazmorra (opcional)",
        dungeonPlaceholder: "Ej.: Jardín de Invierno",
        listTitle: "Lista de zonas",
        filterZones: "Filtrar las zonas",
        viewAll: "Todas",
        viewOpen: "Abiertas",
        searchPlaceholder: "Buscar una zona o una mazmorra...",
        searchLabel: "Buscar una zona",
        listDesc: "Una zona BDA está privatizada por el servidor: desaparece de las preferencias de los miembros y ya no se asigna en las fichas de reserva (salvo fichas congeladas). El orden sirve de clasificación por defecto para los miembros que no rellenaron sus preferencias. Renombrar una zona actualiza las preferencias de los miembros; las fichas ya guardadas conservan el nombre antiguo.",
        unsaved: "Cambios sin guardar",
        removedCount: "{n} zona(s) eliminada(s)",
        duplicates: "Nombres duplicados",
        unnamed: "Zona sin nombre",
        noMatch: "Ninguna zona coincide con la búsqueda",
        noZone: "Ninguna zona",
        dungeon: "Mazmorra",
        zoneName: "Nombre de la zona",
        formerly: "antes «{name}»",
        reopen: "Volver a abrir la zona a los miembros",
        privatize: "Privatizar la zona (BDA)",
        open: "Abierta",
        moveUp: "Subir",
        moveDown: "Bajar",
        deleteZone: "Eliminar {zone}",
        defaultList: "Lista por defecto",
        defaultListDesc: "Borra la lista personalizada de este servidor y vuelve a la lista de zonas incluida con el sitio.",
        restoreDefault: "Restablecer la lista por defecto"
    },
    tempoAdmin: {
        loadError: "Error al cargar la configuración de tempo",
        pickChannel: "Elige el canal de tempo",
        tierIncomplete: "Cada tramo necesita un mínimo y un número de puntos",
        saved: "Configuración de tempo guardada",
        activated: "Nuevo sistema de tempo activado",
        saveError: "Error al guardar",
        loading: "Cargando la configuración de tempo...",
        subtitle: "Puntos otorgados según la duración de los combates",
        saving: "Guardando...",
        save: "Guardar",
        activate: "Activar el nuevo sistema",
        activeChannel: "Nuevo sistema activo · canal #{channel}",
        unsaved: "Cambios sin guardar",
        switchTitle: "Cambio al nuevo sistema",
        switchDesc: "Un solo canal: los miembros publican su captura con la duración, y los puntos dependen del tramo.",
        switchLegacy: "Las capturas ya contadas con el sistema antiguo (un canal por tramo) conservan sus puntos en todas las temporadas.",
        channelTitle: "Canal de tempo",
        discordChannel: "Canal de Discord",
        selectChannel: "-- Seleccionar un canal --",
        tiersTitle: "Baremo por duración",
        addTier: "Añadir un tramo",
        tiersDesc: "Límites incluidos. Deja el máximo vacío para «y más».",
        from: "De",
        to: "a",
        tierMin: "Tramo {n}: mínimo en minutos",
        tierMax: "Tramo {n}: máximo en minutos",
        tierPoints: "Tramo {n}: puntos",
        deleteTier: "Eliminar el tramo {n}",
        simulation: "Simulación",
        fightDuration: "Duración del combate (minutos)",
        points: "puntos",
        forMembers: "Para los miembros",
        howTo: "En el canal de tempo, publica la captura con la duración y menciona a los jugadores. Cada jugador mencionado recibe los puntos.",
        example: "@Jugador1 @Jugador2 1h30",
        formats: "Formatos aceptados: 45 · 45 min · 1h · 1h30. El bot reacciona ⏱️ cuando se cuenta, ❓ si no encuentra la duración.",
        legacyTitle: "Baremo antiguo por canal (conservado para las capturas antiguas)",
        channel: "Canal",
        tier: "Tramo",
        pointsCol: "Puntos"
    },
    resaList: {
        loadError: "❌ No se pudieron cargar las fichas",
        enabledToast: "✅ Reserva activada para los miembros",
        disabledToast: "Reserva desactivada para los miembros",
        toggleError: "❌ No se pudo cambiar la activación",
        created: "✅ ¡Ficha creada!",
        createError: "❌ Error al crear",
        renamed: "✅ Ficha renombrada",
        renameError: "❌ Error al renombrar",
        confirmDelete: "¿Eliminar «{title}»? Esta acción es irreversible.",
        deleted: "🗑️ Ficha eliminada",
        deleteError: "❌ Error al eliminar",
        copySuffix: "(copia)",
        copyName: "Nombre de la copia:",
        copyNameEmpty: "❌ El nombre de la copia no puede estar vacío",
        copied: "✅ Ficha copiada ({n} fila(s))",
        copyError: "❌ Error al copiar la ficha",
        statusLive: "En curso",
        statusSwap: "Intercambios abiertos",
        statusFrozen: "Congelada",
        statusClosed: "Cerrada",
        subtitle: "Crea y gestiona tus fichas de reserva",
        newSheet: "Nueva ficha",
        featureOn: "Reserva activada para los miembros",
        featureOff: "Reserva desactivada para los miembros",
        featureOnDesc: "Los miembros ven las pestañas «Mis preferencias», «Ficha de reserva» y «Subastas» en su espacio.",
        featureOffDesc: "Las pestañas de reserva están ocultas en el espacio de miembro. Aun así puedes preparar tus fichas aquí.",
        toggleLabel: "Activar la reserva para los miembros",
        sheetsCount: "{n} fichas",
        sheetCount: "{n} ficha",
        liveCount: "{n} en curso",
        swapsOpen: "{n} intercambios abiertos",
        swapOpen: "{n} intercambio abierto",
        sheetName: "Nombre de la ficha",
        sheetNamePlaceholder: "Ej.: Ficha S7 — Semana 1",
        creating: "Creando...",
        create: "Crear",
        sheets: "Fichas",
        searchPlaceholder: "Buscar una ficha...",
        searchLabel: "Buscar una ficha",
        noSheet: "Ninguna ficha creada",
        noMatch: "Ninguna ficha coincide con tu búsqueda.",
        createFirst: "Crear la primera ficha",
        sheet: "Ficha",
        status: "Estado",
        createdOn: "Creada el",
        newName: "Nuevo nombre de la ficha",
        rename: "Renombrar",
        renameItem: "Renombrar {title}",
        open: "Abrir",
        copySheet: "Copiar la ficha",
        copyItem: "Copiar {title}",
        deleteSheet: "Eliminar la ficha",
        deleteItem: "Eliminar {title}"
    },
    auctionAdmin: {
        recapTitle: "Resumen por miembro",
        recapLine: "• {name} — {n} zona(s) ({zones}) → {total}",
        recapCopied: "Resumen copiado",
        recapCopyError: "No se puede copiar el resumen",
        recapProvisional: "Provisional",
        copy: "Copiar",
        member: "Miembro",
        confirmDelete: "¿Eliminar definitivamente «{title}» del historial?\n\nSus zonas, pujas y pagos se borrarán y ya no contarán en las estadísticas.",
        deleted: "Subasta eliminada",
        deleteError: "No se puede eliminar la subasta",
        deleteAuction: "Eliminar {title}",
        deleteTitle: "Eliminar del historial",
        confirmLaunch: "¿Lanzar la subasta de las zonas libres de «{title}» hasta el {date}?",
        theSheet: "la ficha",
        launched: "Subasta lanzada",
        launchError: "No se pudo lanzar la subasta",
        launchTitle: "Lanzar una subasta",
        launchDesc: "Todas las zonas que quedaron libres en la ficha (salvo las zonas BDA) salen a subasta. Los ganadores obtienen su zona hasta el final de la temporada.",
        sheet: "Ficha de reserva",
        pickSheet: "— Elegir una ficha —",
        frozenSuffix: "(congelada)",
        endsAt: "Fin de la subasta",
        oneDay: "1 día",
        twoDays: "2 días",
        startingBid: "Puja inicial (kamas)",
        minIncrement: "Puja mínima adicional (kamas)",
        antiSnipe: "Anti-snipe (minutos)",
        channel: "Canal de Discord de las subastas",
        pickChannel: "— Elegir un canal —",
        channelHint: "El bot anuncia allí la apertura, etiqueta al jugador superado en cada puja y publica los resultados.",
        launching: "Lanzando...",
        launch: "Lanzar la subasta",
        confirmCloseNow: "¿Cerrar ahora? Las zonas aún abiertas terminan inmediatamente y ganan las mejores pujas actuales.",
        confirmClose: "¿Cerrar la subasta y anunciar los resultados?",
        closed: "Subasta cerrada",
        closeError: "No se pudo cerrar",
        running: "En curso",
        toClose: "Terminada · por cerrar",
        zones: "Zonas",
        zonesWithBid: "Zonas con puja",
        bids: "Pujas",
        bidsTotal: "Total de pujas",
        meta: "Fin prevista el {date} · salida {start} · +{inc} mínimo · anti-snipe {n} min",
        follow: "Seguir la subasta",
        closing: "Cerrando...",
        close: "Cerrar",
        subtitle: "Zonas libres en subasta tras la fase de intercambio",
        paymentsToTrack: "Pagos pendientes",
        unpaidZones: "{n} zona(s) sin pagar",
        statistics: "Estadísticas",
        auctions: "Subastas",
        zonesSold: "Zonas vendidas",
        avgPrice: "Precio medio",
        totalSold: "Total vendido",
        leftToPay: "Pendiente de pago",
        topZones: "Zonas más caras",
        topBuyers: "Mayores compradores",
        zonesN: "{n} zonas",
        zoneN: "{n} zona",
        history: "Historial",
        noHistory: "Ninguna subasta terminada por ahora.",
        auction: "Subasta",
        closedOn: "Cerrada el",
        total: "Total",
        paid: "Pagadas",
        detail: "Detalle",
        filterAll: "Todas",
        filterBids: "Con puja",
        filterNone: "Sin puja",
        filterUnpaid: "Sin pagar",
        paidError: "No se pudo actualizar el pago",
        confirmRemoveBid: "¿Retirar la puja de {name} ({amount})? La mejor puja restante vuelve a ir en cabeza.",
        bidRemoved: "Puja retirada",
        removeBidError: "No se pudo retirar la puja",
        confirmCloseDetail: "¿Cerrar ahora? Las zonas aún abiertas terminan inmediatamente y se anuncian los resultados.",
        notFound: "Subasta no encontrada.",
        backToAuctions: "Volver a las subastas",
        closedOnDate: "Cerrada el {date}",
        endsIn: "Termina en {time}",
        allEnded: "Todas las zonas han terminado",
        paidSingular: "Pagado",
        filterZones: "Filtrar las zonas",
        searchPlaceholder: "Zona o jugador...",
        zone: "Zona",
        bestBid: "Mejor puja",
        player: "Jugador",
        end: "Fin",
        won: "Ganada",
        unsold: "Sin vender",
        paidFor: "Pagado: {zone}",
        removed: "Retirada",
        removeBidTitle: "Retirar esta puja (puja falsa)",
        actions: "Acciones",
        zoneName: "Nombre de la zona",
        dungeonOptional: "Mazmorra (opcional)",
        dungeon: "Mazmorra",
        save: "Guardar",
        cancel: "Cancelar",
        lotSaved: "Zona modificada",
        lotSaveError: "No se pudo modificar la zona",
        confirmDeleteLotBids: "¿Quitar la zona «{zone}» de la subasta? Sus {n} puja(s) también se eliminarán.",
        confirmDeleteLot: "¿Quitar la zona «{zone}» de la subasta?",
        lotDeleted: "Zona quitada de la subasta",
        lotDeleteError: "No se pudo quitar la zona",
        editLot: "Modificar la zona",
        editLotFor: "Modificar: {zone}",
        deleteLot: "Quitar la zona de la subasta",
        deleteLotFor: "Quitar: {zone}",
        removeBid: "Retirar esta puja",
        noZone: "Ninguna zona"
    },
    createSeasonModal: {
        botOffline: "El bot de Discord no está conectado, vuelve a intentarlo en unos instantes.",
        loadError: "No se pudieron cargar los canales y baremos del servidor.",
        required: "Campo obligatorio",
        endAfterStart: "La fecha de fin debe ser posterior a la de inicio",
        created: "Temporada «{title}» creada",
        createError: "Error al crear la temporada",
        title: "Nueva temporada",
        progress: "Campos obligatorios rellenados",
        loading: "Cargando canales y baremos...",
        season: "Temporada",
        name: "Nombre de la temporada",
        namePlaceholder: "Ej.: Temporada 12 — Otoño",
        publicationChannel: "Canal de publicación",
        pickChannel: "— Elegir un canal —",
        startDate: "Fecha de inicio",
        endDate: "Fecha de fin",
        baremesChannels: "Baremos y canales",
        attackBareme: "Baremo de ataque",
        noAttackBareme: "Ningún baremo de ataque: crea uno en Baremos.",
        pickBareme: "— Elegir un baremo —",
        defenseBareme: "Baremo de defensa",
        noDefenseBareme: "Ningún baremo de defensa: crea uno en Baremos.",
        channelConfig: "Configuración de canales",
        channelConfigHint: "Canales de ataque y defensa que cuentan para esta temporada",
        defaultConfig: "Configuración por defecto del servidor",
        defaultSuffix: "(por defecto)",
        descOptions: "Descripción y opciones",
        description: "Descripción",
        descPlaceholder: "Objetivos, recompensas, reglas especiales...",
        autoPublish: "Publicar automáticamente la clasificación al final de la temporada",
        includeTempo: "Incluir los puntos de tempo",
        creating: "Creando...",
        create: "Crear la temporada"
    },
    editSeason: {
        notFound: "Temporada no encontrada",
        configSaved: "Configuración guardada",
        configSaveError: "Error al guardar la configuración",
        adjustFailures: "{n} ajuste(s) no se pudieron guardar",
        rankingSaved: "Clasificación guardada",
        rankingSaveError: "Error al guardar la clasificación",
        noPlayer: "Ningún jugador en la clasificación",
        namesUpdated: "{n} nombres actualizados",
        namesPartial: "{n}/{total} nombres recuperados, vuelve a intentarlo si hace falta",
        nothingToExport: "Ninguna clasificación que exportar",
        csvRank: "Puesto",
        csvPlayer: "Jugador",
        csvAttack: "Pts ataque",
        csvDefense: "Pts defensa",
        csvTempo: "Pts tempo",
        csvBase: "Puntos base",
        csvAdjust: "Ajuste",
        csvTotal: "Total",
        saveRankingFirst: "Guarda primero los cambios de la clasificación",
        published: "Clasificación publicada en Discord",
        publishError: "Error en la publicación: {error}",
        loading: "Cargando la temporada...",
        mergeTitle: "Fusionar esta clasificación con otras temporadas",
        merge: "Fusionar",
        publish: "Publicar",
        status: {
            archived: "Archivada",
            upcoming: "Próxima",
            ended: "Terminada",
            running: "En curso"
        },
        rankedPlayers: "{n} jugadores clasificados",
        rankedPlayer: "{n} jugador clasificado",
        configuration: "Configuración",
        none: "— Ninguno —",
        saving: "Guardando...",
        saveRecalc: "Guardar y recalcular",
        ranking: "Clasificación",
        searchPlayer: "Buscar un jugador...",
        searchPlayerLabel: "Buscar un jugador",
        namesTitle: "Volver a obtener los nombres desde Discord",
        namesLoading: "Nombres...",
        names: "Nombres",
        exportTitle: "Exportar en formato CSV (Excel)",
        export: "Exportar CSV",
        unsavedAdjusts: "{n} ajustes sin guardar",
        unsavedAdjust: "{n} ajuste sin guardar",
        save: "Guardar",
        computing: "Calculando la clasificación...",
        noPlayerMatch: "Ningún jugador coincide con la búsqueda",
        noFight: "Ningún combate registrado en esta temporada",
        player: "Jugador",
        attack: "Ataque",
        defense: "Defensa",
        tempo: "Tempo",
        points: "Puntos",
        adjustment: "Ajuste",
        total: "Total",
        adjustFor: "Ajuste de puntos para {name}",
        publishTitle: "Publicar la clasificación",
        publishDesc: "La clasificación de {n} jugadores se publicará en el canal elegido.",
        noChannel: "Ningún canal disponible: comprueba que el bot ve los canales del servidor.",
        searchChannel: "Buscar un canal...",
        searchChannelLabel: "Buscar un canal",
        seasonChannel: "canal de la temporada",
        publishing: "Publicando..."
    },
    adminSite: {
        filterAdmins: "Administradores",
        filterAll: "Todo el mundo",
        roles: {
            owner: "Propietario",
            siteAdmin: "Administrador del sitio",
            serverAdmin: "Administrador de servidor",
            member: "Miembro"
        },
        perms: {
            configuration: "Configuración",
            bareme: "Baremos",
            tempo: "Tempo",
            saisons: "Temporadas",
            fusion: "Fusión",
            zones: "Zonas",
            reservation: "Reservas",
            statistiques: "Estadísticas",
            pepites: "Pepitas",
            encheres: "Subastas",
            evenements: "Eventos",
            rattrapage: "Recuperación",
            pl: "Servicio PL",
            personnages: "Personajes"
        },
        rightsSaved: "Permisos de {name} guardados",
        rightsSaveError: "Error al guardar los permisos",
        rightsOf: "Permisos de {name}",
        rightsIntro: "Marca las páginas accesibles en cada servidor. Un servidor sin ninguna página no aparece en su espacio de administración.",
        searchServer: "Buscar un servidor...",
        searchServerLabel: "Buscar un servidor",
        none: "Ninguno",
        all: "Todo",
        noServerMatch: "Ningún servidor coincide.",
        saving: "Guardando...",
        save: "Guardar",
        loadError: "No se pudieron cargar los administradores",
        confirmPromote: "¿Nombrar a {name} Administrador del sitio?\n\nEsta persona tendrá todos los permisos en todos los servidores y podrá gestionar a los Administradores de servidor.",
        confirmDemote: "¿Quitar el rol de Administrador del sitio a {name}?",
        promoted: "{name} ahora es Administrador del sitio",
        demoted: "{name} ya no es Administrador del sitio",
        roleError: "Error al cambiar el rol",
        title: "Administración del sitio",
        subtitleOwner: "Propietario · gestión de los administradores",
        subtitleAdmin: "Administrador del sitio · gestión de los Administradores de servidor",
        serversWithBot: "Servidores con el bot",
        usersLogged: "Usuarios conectados",
        siteAdmins: "Admins del sitio",
        serverAdmins: "Admins de servidor",
        admins: "Administradores",
        searchPlaceholder: "Nombre o ID de Discord...",
        searchLabel: "Buscar a una persona",
        howTo: "Para dar permisos a alguien, debe haberse conectado al sitio al menos una vez: búscalo en «Todo el mundo».",
        ownerOnly: "Solo el propietario puede nombrar Administradores del sitio.",
        noMatch: "Nadie coincide con la búsqueda",
        noAdmin: "Ningún administrador por ahora",
        fullAccess: "Todos los permisos en todos los servidores",
        noAccess: "Sin acceso de administración",
        allRights: "todo",
        rightsN: "{n} permisos",
        rightN: "{n} permiso",
        serverRights: "Permisos de servidor",
        siteAdmin: "Admin del sitio",
        siteAdminFor: "Administrador del sitio: {name}"
    },
    botCommands: {
        title: "Comandos del bot",
        hint: "Para escribir en Discord, en el servidor donde está el bot.",
        nullos: {
            description: "Lista los miembros del servidor de Discord que no participaron en ningún combate (ataque, defensa o tempo) durante la temporada elegida, es decir, con 0 puntos.",
            access: "Rol especial definido en Configuración"
        },
        mp: {
            description: "Envía el mensaje en privado a todos los miembros que tienen el rol elegido.",
            access: "Administrador de Discord"
        },
        potionsRecolte: {
            description: "Registra una recolección, con la llave usada (Vortex, Solar o ninguna).",
            access: "Rol «Gestionnaire BDA»"
        },
        potionsPose: {
            description: "Registra una colocación: añade una poción al contador del jugador.",
            access: "Rol «Gestionnaire BDA»"
        },
        potionsRecap: {
            description: "Muestra las pociones y llaves usadas por cada uno.",
            access: "Rol «Gestionnaire BDA»"
        },
        potionsClear: {
            description: "Pone a cero las pociones y llaves de un miembro.",
            access: "Rol «Gestionnaire BDA»"
        }
    },
    maintenance: {
        badge: "Sitio en obras",
        text: "Pronto llegará una nueva versión del sitio. El bot de Discord sigue funcionando con normalidad.",
        denied: "Tu cuenta no tiene acceso al sitio durante las obras.",
        login: "Conectarse con Discord",
        hint: "Acceso reservado al equipo durante las obras."
    },
    baremePage: {
        deleteItem: "Eliminar {name}",
        alliesEnemies: "Aliados / enemigos",
        fixedTitle: "Puntos fijos «contra todos»",
        optional: "(opcional)",
        fixedDefense: "Puntos fijos de defensa contra todos",
        fixedAttack: "Puntos fijos de ataque contra todos",
        example25: "Ej.: 25"
    },
    seasonsPage: {
        visibleInStats: "✅ Temporada visible en las estadísticas de los miembros",
        hiddenFromStats: "🚫 Temporada oculta de las estadísticas de los miembros",
        visibilityError: "❌ No se pudo cambiar la visibilidad"
    },
    mergePage: {
        showLess: "Mostrar menos",
        showMore: "Ver las otras {n} temporadas",
        nothingToRestore: "Ninguna clasificación generada que restaurar.",
        localReset: "✅ Cambios locales anulados.",
        channelsError: "No se pudo cargar la lista de canales de Discord.",
        pickChannel: "Selecciona un canal de publicación.",
        published: "✅ ¡Clasificación fusionada publicada!",
        publishError: "Error al publicar.",
        csvLocal: "Cambio local",
        csvParticipations: "Participaciones",
        exported: "📥 ¡Clasificación exportada!",
        partnerError: "Error al cargar las temporadas del servidor asociado.",
        min2Total: "Selecciona al menos 2 temporadas en total.",
        min2: "Selecciona al menos 2 temporadas.",
        crossError: "Error en la fusión entre servidores.",
        mergeError: "Error al fusionar las clasificaciones.",
        title: "Fusión de clasificaciones",
        subtitle: "Combina varias temporadas, de uno o varios servidores, en una sola clasificación",
        toMerge: "Temporadas por fusionar",
        selectedN: "{n} temporadas seleccionadas",
        selected1: "{n} temporada seleccionada",
        uncheckAll: "Desmarcar todo",
        merging: "Fusionando...",
        regenerate: "Regenerar la clasificación",
        generate: "Generar la clasificación",
        servers: "Servidores",
        removeServer: "Quitar este servidor",
        addServer: "Añadir las temporadas de este servidor",
        searchSeason: "Buscar una temporada...",
        searchSeasonLabel: "Buscar una temporada",
        showArchived: "Mostrar las temporadas archivadas ({n})",
        thisServer: "Este servidor",
        noSeason: "Ninguna temporada disponible.",
        noSeasonServer: "Ninguna temporada disponible en este servidor.",
        noResult: "Ninguna clasificación generada",
        noResultHint: "Marca al menos 2 temporadas a la izquierda y haz clic en «Generar la clasificación».",
        merged: "Clasificación fusionada",
        resultMeta: "{players} jugadores · {seasons} temporadas",
        undo: "Anular los cambios",
        export: "Exportar (.csv)",
        stale: "La selección ha cambiado desde la generación.",
        regenerateShort: "Regenerar",
        partShort: "Part.",
        adjustTitle: "Añadir/quitar puntos localmente",
        adjustFor: "Ajuste: {name}",
        removePlayer: "Quitar a este jugador de la clasificación fusionada",
        removeName: "Quitar a {name}",
        publishTitle: "Publicar la clasificación fusionada",
        customTitle: "Título personalizado (opcional)",
        customTitlePlaceholder: "Ej.: Clasificación VSA Dakal × Mikhal — Mayo 2026",
        channelsN: "{n} canales",
        loadingChannels: "Cargando canales...",
        noChannel: "Ningún canal disponible. Comprueba que el bot está en este servidor.",
        noChannelMatch: "Ningún canal coincide.",
        loadFusionError: "No se puede cargar esta fusión.",
        deleteFusionConfirm: "¿Eliminar la fusión «{title}»? Las fichas de reserva que la usan ya no tendrán clasificación.",
        fusionDeleted: "🗑️ Fusión eliminada.",
        deleteFusionError: "Error al eliminar.",
        fusionPrefix: "Fusión",
        and: "y",
        fusionTitleRequired: "Ponle un nombre a la fusión.",
        fusionSaved: "✅ Fusión guardada: ya está disponible en las fichas de reserva.",
        saveFusionError: "Error al guardar la fusión.",
        savedFusions: "Fusiones guardadas",
        loadFusion: "Cargar esta fusión",
        nSeasons: "{n} temporadas",
        deleteFusion: "Eliminar la fusión {title}",
        deleteFusionShort: "Eliminar",
        saveFusion: "Guardar la fusión",
        fusionName: "Nombre de la fusión",
        fusionNamePlaceholder: "Ej.: Fusión - Temporada 15 y 16",
        saveFusionHint: "La fusión aparecerá como una temporada en las fichas de reserva. Su clasificación sigue a las temporadas de origen; se conservan tus ajustes y jugadores retirados.",
        saveAsNew: "Guardar como nueva",
        updateFusion: "Actualizar"
    },
    channelPage: {
        vsEnemy: "Contra {n} enemigo",
        vsEnemies: "Contra {n} enemigos",
        selectChannel: "Seleccionar un canal",
        migrated: "¡Configuración existente migrada automáticamente!",
        loadError: "Error al cargar los datos",
        nameRequired: "El nombre de la configuración es obligatorio",
        created: "¡Configuración creada!",
        updated: "¡Configuración actualizada!",
        nameTaken: "Ya existe una configuración con este nombre",
        saveError: "Error al guardar",
        confirmDelete: "¿Eliminar la configuración «{name}»?",
        deleted: "Configuración «{name}» eliminada",
        deleteError: "Error al eliminar",
        defaultSet: "Configuración definida por defecto",
        updateError: "Error al actualizar",
        loading: "Cargando configuraciones...",
        newConfig: "Nueva configuración",
        configsN: "{n} configuraciones",
        config1: "{n} configuración",
        channelsAvailable: "{n} canales disponibles",
        channelAvailable: "{n} canal disponible",
        none: "Ninguna configuración creada",
        noneHint: "Crea tu primera configuración para empezar",
        default: "Por defecto",
        setDefault: "Definir por defecto",
        duplicate: "Duplicar",
        configuredN: "{n} canales configurados",
        configured1: "{n} canal configurado",
        modifiedOn: "Modificada el {date}",
        editConfig: "Modificar la configuración",
        closeForm: "Cerrar el formulario",
        name: "Nombre de la configuración *",
        namePlaceholder: "Ej.: Sección PvP, Sección GvG...",
        description: "Descripción",
        descriptionPlaceholder: "Descripción opcional...",
        specialRole: "Rol especial",
        noSpecialRole: "Ningún rol especial",
        isDefault: "Configuración por defecto",
        attack: "Ataque",
        defense: "Defensa",
        typesN: "{n} tipos",
        generic: "Canales genéricos",
        genericDesc: "Si solo tienes 1 o 2 canales para todos los ataques y defensas, usa estos campos como solución de respaldo.",
        anyAttack: "Ataque — para todos los ataques",
        anyAttackHint: "Se usa si no hay ningún canal específico (Ataque contra N) configurado",
        anyDefense: "Defensa — para todas las defensas",
        anyDefenseHint: "Se usa si no hay ningún canal específico (Defensa contra N) configurado"
    },
    resaEdit: {
        bulkAdd: "Añadir",
        bulkCount: "Número de filas a añadir",
        bulkRowsWith: "filas con",
        bulkSeason: "Temporada de las nuevas filas",
        bulkNoSeason: "— sin temporada —",
        bulkAddBtn: "Añadir filas",
        groupSeasons: "Temporadas",
        groupFusions: "Fusiones",
        configLoadError: "❌ No se pudo cargar la configuración",
        loadError: "❌ No se pudieron cargar las reservas",
        pickSheetFirst: "❌ Selecciona o crea una ficha primero",
        saved: "✅ ¡Ficha guardada!",
        saveError: "❌ Error al guardar",
        liveSet: "📌 ¡Ficha definida como ficha en curso!",
        liveUnset: "📌 Ficha en curso retirada",
        updateError: "❌ Error al actualizar",
        thisSheet: "esta ficha",
        published: "✅ ¡Ficha publicada en el canal de Discord!",
        publishError: "❌ Error al publicar",
        frozenToast: "🔒 Ficha congelada — las zonas ya no se recalcularán automáticamente",
        unfrozenToast: "🔓 Ficha descongelada — la asignación automática vuelve a estar activa",
        statusError: "❌ Error al cambiar el estado",
        swapOpened: "🔄 Ventana de intercambio abierta — ¡los miembros pueden cambiar de zona!",
        swapClosed: "🔒 Ventana de intercambio cerrada",
        changeError: "❌ Error al cambiar",
        prefsSaved: "✅ Preferencias guardadas para {name}",
        prefsSaveError: "❌ Error al guardar las preferencias",
        editPrefs: "Modificar las preferencias de zona del jugador",
        pickZoneManually: "Elegir la zona manualmente",
        manualZone: "Zona elegida manualmente",
        backToAuto: "Volver a la asignación automática",
        auto: "Auto",
        zoneFrozen: "Zona congelada",
        defaultOrder: "Orden por defecto (sin preferencias)",
        conflict: "Conflicto",
        conflictHint: "Todas sus preferencias están ocupadas",
        set: "Definir",
        noPrefs: "Sin preferencias",
        noPrefsHint: "El jugador no ha rellenado sus preferencias",
        back: "Fichas de reserva",
        subtitle: "{players} jugador(es) · {zones} zona(s) asignada(s)",
        auctionTitle: "Sacar a subasta las zonas que quedaron libres en esta ficha",
        saveSheet: "Guardar la ficha",
        isLive: "Ficha en curso",
        setLive: "Definir en curso",
        isLiveHint: "Visible para los miembros",
        setLiveHint: "Hacerla visible para los miembros",
        isFrozen: "Ficha congelada",
        freeze: "Congelar la ficha",
        isFrozenHint: "Las zonas ya no se mueven",
        freezeHint: "Bloquear las zonas asignadas",
        swapsOpen: "Intercambios abiertos",
        openSwaps: "Abrir los intercambios",
        swapsOpenHint: "Los miembros pueden cambiar de zona",
        openSwapsHint: "Dejar que los miembros cambien de zona",
        dragHint: "Arrastra las filas para cambiar el orden de prioridad",
        dragToReorder: "Arrastra para reordenar",
        publishTitle: "Publicar en un canal",
        publishDesc: "Envía la ficha tal como está guardada a un canal de Discord.",
        destination: "Canal de destino",
        selectChannel: "— Seleccionar un canal —",
        deleteDesc: "Elimina definitivamente la ficha y todas sus reservas.",
        prefsOf: "Preferencias de {name}",
        prefsDesc: "Zonas por orden de prioridad, guardadas para este jugador.",
        prefN: "Preferencia {n}",
        pickZone: "— Elegir una zona —",
        removePrefN: "Quitar la preferencia {n}"
    },
    recovery: {
        openImage: "Abrir la captura",
        screenAlt: "Captura del mensaje",
        noImage: "Captura no disponible",
        pepitesAmount: "{n} pepitas",
        tempoMinutes: "{m} min → {p} pts",
        tempoLegacy: "Tempo (sistema antiguo, puntos según el canal)",
        allEnemies: "todos",
        combat: "{allies} aliados contra {enemies} enemigos",
        select: "Seleccionar",
        kinds: {
            attaque: "Ataque",
            defense: "Defensa",
            tempo: "Tempo",
            pepite: "Pepitas"
        },
        by: "por {name}",
        duplicate: "Parece un envío ya contado el {date}",
        see: "ver",
        openDiscord: "Ver en Discord",
        reject: "Rechazar",
        accept: "Aceptar",
        restore: "Volver a validar",
        acceptedOn: "Aceptado el {date}",
        rejectedOn: "Rechazado el {date}",
        loadError: "No se pudieron cargar los mensajes por validar",
        scanError: "No se pudo lanzar la búsqueda",
        confirmDuplicates: "{n} mensaje(s) parecen envíos ya contados (probables duplicados). ¿Aceptarlos de todos modos?",
        confirmAccept: "¿Aceptar {n} mensajes? Se contarán como si se hubieran registrado en su fecha de envío.",
        confirmReject: "¿Rechazar {n} mensajes?",
        accepted: "{n} mensaje(s) aceptado(s) y contabilizado(s)",
        rejected: "{n} mensaje(s) rechazado(s)",
        failed: "{n} mensaje(s) no se pudieron procesar",
        decideError: "Error al guardar la decisión",
        restoreError: "No se pudo volver a poner este mensaje por validar",
        subtitle: "Capturas y pepitas publicadas mientras el bot no las veía: nada cuenta antes de validarlo",
        scanTitle: "Buscar los mensajes perdidos",
        scanDesc: "El bot vuelve a leer todos los canales configurados (ataque, defensa, tempo, pepitas) en el periodo elegido y coloca aquí los mensajes que no registró. También lo hace solo en cada reinicio.",
        from: "Desde",
        to: "Hasta",
        scanning: "Buscando...",
        scan: "Lanzar la búsqueda",
        maxRange: "Periodo de {n} días como máximo.",
        scanRunning: "Buscando del {from} al {to}...",
        scanFailed: "La búsqueda falló: {error}",
        scanDone: "{channels} canales releídos, {scanned} mensajes leídos, {found} nuevo(s) por validar",
        scanChannelErrors: "{n} canal(es) inaccesible(s)",
        lastAuto: "Última recuperación automática (reinicio del bot): {date}",
        statusLabel: "Estado",
        status: {
            review: "Por validar",
            accepted: "Aceptados",
            rejected: "Rechazados"
        },
        kindLabel: "Tipo",
        allKinds: "Todo",
        selectAll: "Seleccionar todo ({n})",
        rejectSelected: "Rechazar la selección ({n})",
        acceptSelected: "Aceptar la selección ({n})",
        emptyReview: "Nada por validar: el bot no se ha perdido nada.",
        empty: "Ningún mensaje."
    },
    pl: {
        lendNow: "Prestar un kit ahora mismo",
        lendAfterCreateError: "Ficha creada, pero el préstamo falló: {error}",
        lendIntro: "Se presta el kit completo ({n} ítems). La captura sirve de prueba.",
        lendKit: "Prestar el kit",
        noFreeKit: "Ningún kit completo disponible.",
        noKits: "Ningún kit. Añade un kit: viene con la panoplia de sabiduría.",
        addItem: "Añadir un ítem",
        addKit: "Añadir un kit",
        aid: "Ayuda de {amount}",
        aidShort: "Ayuda",
        atHolder: "lo tiene {name}",
        available: "Disponible",
        clientDeleted: "Ficha eliminada",
        clients: "Beneficiarios",
        clientSaved: "Ficha guardada",
        confirmCloseWithItems: "{name} todavía tiene {n} ítem(s). ¿Marcarlos como faltantes?",
        confirmDeleteClient: "¿Eliminar la ficha de {name} y su historial?",
        confirmDeleteKit: "¿Eliminar «{name}»?",
        confirmNoScreen: "No hay captura adjunta. ¿Continuar de todos modos?",
        create: "Crear",
        deleteClient: "Eliminar la ficha",
        deleteError: "No se pudo eliminar",
        deleteKit: "Eliminar el kit",
        edit: "Editar",
        editKit: "Editar el kit",
        filterAll: "Todos",
        filterOver: "Terminados",
        heldItems: "Ítems en su poder",
        history: "Historial",
        item: "Ítem",
        items: "Ítems",
        kit: "Kit",
        kitAllHere: "{n} ítems, todos guardados",
        kitCreated: "Kit creado con la panoplia de sabiduría por defecto",
        kitName: "Nombre del kit",
        kits: "Panoplias de sabiduría",
        kitSaved: "Kit guardado",
        kpiActive: "PL en curso",
        kpiAid: "Ayudas concedidas",
        kpiCollected: "Cobrado",
        kpiLent: "Ítems prestados",
        kpiLentMissing: "Ítems fuera, {n} faltante(s)",
        kpiUnpaid: "Por cobrar",
        lend: "Prestar",
        lendScreen: "Captura del préstamo",
        lendTo: "Prestar a {name}",
        lent: "Préstamo guardado",
        lentCount: "{n}/{total} prestados",
        lentShort: "Prestado",
        levelN: "niv. {n}",
        loadError: "No se pudo cargar el servicio PL.",
        loan: "Préstamo",
        loanScreens: "Capturas del momento del préstamo",
        missing: "Faltante",
        missingCount: "{n} ítem(s) faltante(s)",
        missingN: "{n} faltante(s)",
        newClient: "Nuevo PL",
        noClients: "Ningún beneficiario.",
        noHistory: "Ningún préstamo por ahora.",
        note: "Nota",
        notes: "Notas",
        nothingHeld: "Este jugador no tiene ningún ítem.",
        open: "Abrir",
        paid: "Tarifa pagada",
        paidShort: "Pagado",
        player: "Jugador",
        price: "Tarifa (kamas)",
        priceShort: "Tarifa",
        removeItem: "Quitar el ítem",
        removeScreen: "Quitar la captura",
        return: "Devolución",
        returned: "Devolución guardada",
        returnFrom: "Devolución de {name}",
        returnIntro: "Desmarca lo que no se devolvió: esos ítems quedan a nombre del jugador.",
        returnN: "Validar la devolución de {n} ítem(s)",
        returnScreen: "Captura de la devolución",
        returnShort: "Devolución",
        saveError: "No se pudo guardar",
        saving: "Guardando...",
        screenError: "No se pudo leer esta imagen",
        screenHint: "Pega la captura (Ctrl+V), suéltala aquí o haz clic para elegirla",
        since: "desde el {date}",
        slot: "Emplazamiento",
        startedOn: "Inicio",
        startLevel: "Nivel inicial",
        status: "Estado",
        statusActive: "En curso",
        statusCancelled: "Abandonado",
        statusDone: "Terminado",
        subtitle: "Seguimiento de beneficiarios y panoplias de sabiduría prestadas",
        unpaidShort: "Por pagar"
    },
    personnages: {
        typeAdd: "Alta",
        typeEdit: "Modificación",
        typeRemove: "Baja",
        typeMigrate: "Migración",
        statusApproved: "Validada",
        statusRejected: "Rechazada",
        statusPending: "Pendiente",
        migrationRoute: "{from} → {to}",
        requestSent: "Solicitud enviada: un admin debe validarla",
        sendError: "No se pudo enviar la solicitud",
        declare: "Declarar un personaje",
        editTitle: "Modificar {name}",
        name: "Nombre del personaje",
        nameHint: "Exactamente como en el juego: el bot lee este nombre en las capturas.",
        classe: "Clase",
        sendRequest: "Enviar la solicitud",
        migrateSent: "Solicitud enviada: un admin del servidor de destino debe validarla",
        migrateTitle: "Migrar {name}",
        noOtherServer: "No eres miembro de ningún otro servidor donde esté el bot.",
        migrateIntro: "Cuando un admin del servidor de destino valide la solicitud, el personaje quedará registrado allí y dejará de estar vinculado a tu cuenta aquí.",
        targetServer: "Servidor de destino",
        confirmRemove: "¿Pedir dejar de estar vinculado a {name}?",
        cancelError: "No se pudo anular",
        mineTitle: "Mis personajes",
        mineSubtitle: "Los personajes que juegas: el bot los usa para darte los puntos de tus capturas. Cada cambio lo valida un admin.",
        loadError: "No se pudieron cargar los personajes.",
        linked: "Personajes vinculados a mi cuenta",
        noneYet: "Todavía ningún personaje. Declara los que juegas en este servidor.",
        sharedHint: "Otro jugador también tiene acceso a este personaje",
        shared: "Compartido",
        pendingType: "{type} pendiente",
        edit: "Modificar",
        migrate: "Migrar a otro servidor",
        remove: "Dejar de estar vinculado",
        myRequests: "Mis solicitudes",
        noRequests: "Ninguna solicitud.",
        reasonLabel: "Motivo: {reason}",
        cancelRequest: "Anular",
        unknownPlayer: "Jugador {id}",
        rejectPrompt: "Motivo del rechazo (opcional, visible para el jugador):",
        approved: "Solicitud validada",
        rejected: "Solicitud rechazada",
        decideError: "Acción imposible",
        confirmUnlink: "¿Quitar {name} de los personajes de {player}?",
        unlinked: "Vínculo eliminado",
        adminSubtitle: "Censo de los personajes de cada jugador y validación de sus solicitudes",
        kpiPending: "Solicitudes pendientes",
        kpiPlayers: "Jugadores censados",
        kpiPersonnages: "Personajes",
        kpiShared: "Personajes compartidos",
        pendingTitle: "Solicitudes por validar",
        noPending: "Ninguna solicitud pendiente.",
        alreadyPlayedBy: "Ya registrado para {players}: el personaje pasará a ser compartido",
        reject: "Rechazar",
        approve: "Validar",
        census: "Censo",
        searchPlaceholder: "Jugador o personaje...",
        allClasses: "Todas las clases",
        noPlayers: "Todavía no hay personajes censados.",
        noMatch: "Ningún resultado.",
        player: "Jugador",
        characters: "Personajes",
        sharedWith: "Compartido con {players}",
        unlink: "Quitar el vínculo",
        history: "Últimas decisiones",
        hide: "Ocultar",
        show: "Mostrar ({n})",
        noHistory: "Ninguna decisión todavía.",
        reviewedBy: "por {admin}",
        siteSearchPlaceholder: "Usuario, ID de Discord o personaje...",
        serverFilter: "Servidor",
        allServers: "Todos los servidores",
        siteSummary: "{players} cuentas de Discord · {personnages} personajes censados en {servers} servidor(es).",
        sitePending: "Solicitudes pendientes:",
        assignTitle: "Asignar un personaje",
        addFor: "Añadir un personaje a {player}",
        assign: "Asignar",
        assigned: "{name} asignado",
        assignedBy: "asignado directamente por {admin}",
        editedBy: "modificado directamente por {admin}",
        editSharedHint: "Este personaje es compartido: el cambio se aplica a todos sus jugadores.",
        save: "Guardar",
        saved: "{name} modificado",
        changePlayer: "Cambiar",
        memberSearch: "Usuario o ID de Discord...",
        noMember: "Ningún jugador encontrado: pega su ID de Discord.",
        useTypedId: "El personaje se asignará a la cuenta {id}.",
        memberHint: "Jugadores ya vistos por el bot en este servidor. Si no, pega el ID de Discord (clic derecho en el usuario → Copiar ID)."
    },
    classes: {
        feca: "Feca",
        osamodas: "Osamodas",
        enutrof: "Anutrof",
        sram: "Sram",
        xelor: "Xelor",
        ecaflip: "Zurcarák",
        eniripsa: "Aniripsa",
        iop: "Yopuka",
        cra: "Ocra",
        sadida: "Sadida",
        sacrieur: "Sacrógrito",
        pandawa: "Pandawa",
        roublard: "Tymador",
        zobal: "Zobal",
        steamer: "Steamer",
        eliotrope: "Selotrop",
        huppermage: "Hipermago",
        ouginak: "Uginak",
        forgelance: "Forjalanza"
    }
};

export default es;
